import useConfig from './useConfig';
import { useLocation } from '@reach/router';
import useHasMounted from './useHasMounted';

export default function useIsUserTestingSite(): boolean {
    const config = useConfig();
    const location = useLocation();
    // The server doesn't know the hostname, so wait until after hydration,
    // or the first render wouldn't match the server-rendered HTML
    const hasMounted = useHasMounted();

    return (
        hasMounted &&
        config.userTestingHostname !== null &&
        config.userTestingHostname === location.hostname
    );
}
